import React, { Component, PropTypes } from 'react';

import './formButtons.scss';

export default class FormButtons extends Component {

    static contextTypes = {
        intl: PropTypes.object
    }

    render() {
        let {className, children} = this.props;
        return (
            <div className={`form-buttons ${className ? className : ""}`}>
                {children}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/views/formButtons/FormButtons.js